module.exports = __webpack_public_path__ + "img/c6f12250d2f45547504aa8dde641a5ca.d6085a1a.png";